const carousel = {
    setHandlers() {
        const dots = document.querySelectorAll("#dots span");
        const dotsContainer = document.getElementById("dots");
        const isTouch = global.isTouch;
        const left = document.querySelector(".left");
        const right = document.querySelector(".right");
        const slide = document.querySelector("#slider div:first-child");
        const slider = document.getElementById("slider");
        const slides = document.querySelectorAll("#slider > div").length;
        const thumbs = document.querySelectorAll("#thumbnails [data-slide]");
        const thumbsContainer = document.getElementById("thumbnails");
        let slideNumber = 0;
        const slideWidth = slide.offsetWidth;
        const maxIndex = slides - 1;
        const thresholdRatio = 1.3;
        document.querySelectorAll(".direction").forEach(btn =>
            btn.addEventListener("click", function () {
                if (this.classList.contains("left")) {
                    slideNumber = Math.max(0, slideNumber - 1);
                } else {
                    slideNumber = Math.min(maxIndex, slideNumber + 1);
                }

                slider.scrollLeft = slideNumber * slideWidth;
            })
        );
        document.querySelectorAll("#thumbnails [data-slide], #dots span")
            .forEach(el =>
                el.addEventListener("click", function () {
                    slideNumber = Number(this.dataset.slide);
                    slider.scrollLeft = slideNumber * slideWidth;
                })
            );
        slider.addEventListener("scroll", function () {
            const scrollLeft = slider.scrollLeft;
            const maxScroll = slider.scrollWidth - slider.clientWidth;
            const threshold = slider.offsetWidth / thresholdRatio;
            slideNumber = Math.round(scrollLeft / slideWidth);
            if (left) {
                left.style.display =
                    isTouch || scrollLeft < threshold ? "none" : "block";
            }
            if (right) {
                right.style.display =
                    isTouch || scrollLeft > (maxScroll - threshold)
                        ? "none"
                        : "block";
            }
            if (isTouch) {
                dots.forEach(d => d.classList.remove("active"));
                const active = dotsContainer?.querySelector(
                    `[data-slide="${slideNumber}"]`
                );
                active?.classList.add("active");
            } else {
                thumbs.forEach(t => t.classList.remove("active"));
                const active = thumbsContainer?.querySelector(
                    `[data-slide="${slideNumber}"]`
                );
                active?.classList.add("active");
            }
        });
    },
};
$(() => {
    carousel.setHandlers();
});
